Pegasus.ColorImageTabView = Em.View.extend({
  isImageActive: function(){
    return this.get('selectedTab') === 'image';
  }.property('selectedTab'),
  isColorActive: function(){
    return this.get('selectedTab') === 'color';
  }.property('selectedTab'),
  template: function(){
    return Em.Handlebars.compile(
      '<div class="vr-toolbar-tabs">' +
        '<a {{bindAttr class="view.isColorActive:active"}} {{action "showColor" target="view"}} href="#">'+Em.I18n.t('g.color')+'</a>' +
        '<a {{bindAttr class="view.isImageActive:active"}} {{action "showImage" target="view"}} href="#">'+Em.I18n.t('g.image')+'</a>' +
      '</div>' +
      '<div {{bindAttr class="view.selectedTab :vr-toolbar-tabs-content"}}>{{view view.tabContentView}}</div>'
    );
  }.property(),
  showColor: function(){
    this.set('selectedTab', 'color');
  },
  showImage: function(){
    this.set('selectedTab', 'image');
  },
  color: Em.required(),
  image: Em.required(),
  selectedTab: 'image',
  tabContentView: Em.ContainerView.extend({
    currentView: function(){
      return this.get( 'parentView.' + this.get('parentView.selectedTab') ).create();
    }.property('parentView.selectedTab')
  })
});
